import { Tournaments } from '@/routes/Tournaments';

/** Sit&Go — the sit&go list directly (pins the `sitAndGo` view). See EventsPanel. */
export function SitngoPanel() {
  return (
    <div className="-mx-4 h-full">
      <Tournaments forcedView="sitAndGo" />
    </div>
  );
}
